// Português — Portuguese translation. Mirrors the keys in en.js.

const pt = {
  "nav.simulator": "Simulador",
  "nav.rules": "Regras",
  "brand.tagline": "Simulador de Renda",

  "landing.eyebrow": "Simulador de renda ao vivo",
  "landing.title.pre": "Modele suas",
  "landing.title.highlight": "comissões",
  "landing.title.post": "da U.CENTER em tempo real.",
  "landing.subtitle": "Projeção interativa usando as regras de Initial Ripple, Ripple Wave, Deep Ripple e Drop Match de u.center/docs. Configure sua equipe e veja o cálculo atualizar instantaneamente.",
  "landing.cta.primary": "Abrir o simulador",
  "landing.cta.secondary": "Ver as regras",

  "sim.eyebrow": "Simulador de renda ao vivo",
  "sim.title.pre": "Construa sua equipe.",
  "sim.title.highlight": "Veja quanto você ganha.",
  "sim.subtitle": "Construa sua organização nível por nível. Cada etapa adiciona matemática real — comissões e cotas atualizam assim que você configura a próxima camada. Regras de",
  "sim.reset": "Reiniciar",
  "sim.share": "Compartilhar",

  "step.1.title": "Seu pacote inicial",
  "step.1.sub": "Define seu rank inicial e desbloqueia os níveis de Initial Ripple.",
  "step.1.done": "{pkg} · ${price} · Começa em {rank}",
  "step.2.title": "Seus recrutas de Nível 1",
  "step.2.sub": "As pessoas que você traz pessoalmente.",
  "step.2.question": "Quantas pessoas você vai recrutar pessoalmente?",
  "step.2.avgPkg": "Pacote médio que seus diretos vão comprar",
  "step.2.done": "{count} diretos em {pkg} · ${vol} vol",
  "step.level.title": "Equipe de Nível {n}",
  "step.level.sub": "Recrutas feitos por cada membro do Nível {parent}.",
  "step.level.question": "Em média, quantas pessoas cada membro de Nível {parent} recruta?",
  "step.level.avgPkg": "Pacote médio para membros do Nível {n}",
  "step.level.done": "{ratio}/membro de Nível {parent} → {count} em {pkg} · ${vol} vol",
  "step.summary.volume": "Nível {n} · {count} membros",
  "step.summary.volumeShort": "Volume do Nível 1",
  "step.next": "Próximo: Nível {n} →",
  "step.finish": "Adicionar níveis mais profundos (opcional) →",
  "step.of": "Etapa {n} de {total}",
  "step.edit": "Editar",

  "hero.projection": "Projeção na profundidade que você configurou",
  "hero.youEarn": "Você ganha",
  "hero.commissionsSub": "em comissões ({pct}% do volume da organização)",
  "hero.teamGenerates": "Sua equipe gera",
  "hero.teamGeneratesSub": "volume total da organização",
  "hero.teamPayout": "Pagamento da equipe",
  "hero.teamPayoutSub": "comissões pagas em toda a sua equipe",
  "hero.plusShares": "mais cotas",
  "hero.plusSharesSub": "{start} iniciais + {earned} via Drop Match",
  "hero.teamSize": "Tamanho da equipe",
  "hero.teamSizeSub": "membros ativos",
  "hero.yourRank": "Seu rank",
  "hero.perMember": "$ / membro",
  "hero.perMemberSub": "comissão média",
  "hero.avgOrder": "Pedido médio",
  "hero.avgOrderSub": "em toda a sua equipe",
  "hero.next": "Próximo: {rank} · {unlock}",
  "hero.qvToGo": "faltam {qv} QV",

  "empty.title": "Escolha seu pacote para começar",
  "empty.sub": "Suas comissões projetadas, cotas e rank aparecerão aqui à medida que você constrói o cenário passo a passo.",

  "chart.title": "Receita vs tamanho da equipe",
  "chart.sub": "Como suas comissões crescem enquanto sua organização se preenche",
  "chart.footer": "{members} membros · {vol} vol",

  "bonus.ir.title": "Initial Ripple",
  "bonus.ir.subtitle": "Comissões diretas · L1-L5 · {unlocked}/5 desbloqueados",
  "bonus.ir.footer": "O pacote desbloqueia {maxFromPkg}/5. Subir de rank desbloqueia mais.",
  "bonus.ir.rowMembers": "{count} membros · {vol} vol",
  "bonus.ir.rowLocked": "Bloqueado — precisa de {rank}",
  "bonus.ir.rowPotential": "~{amount} pot.",
  "bonus.rw.title": "Ripple Wave",
  "bonus.rw.subtitle": "Comissões de rank R6+ · {unlocked}/6 níveis desbloqueados",
  "bonus.rw.footer": "1% por nível desbloqueado em cada pedido da sua downline (L1–L11). Máximo 3 pagamentos por pedido compartilhados com Initial Ripple.",
  "bonus.rw.rowFires": "Incide sobre {vol} de volume da downline",
  "bonus.rw.rowCapped": "Desbloqueado — limitado pela regra de 3 pagamentos",
  "bonus.rw.rowLocked": "Bloqueado — alcance {rank}",
  "bonus.rw.tag": "Desbloqueia em {rank} · 1% por pedido da downline",
  "bonus.dr.title": "Deep Ripple",
  "bonus.dr.subtitle": "Override de liderança · L12-L20 · exige R12+",
  "bonus.dr.g1": "G1 · R12–R14 (0.3/0.6/0.9%)",
  "bonus.dr.g1sub": "Liderança inicial",
  "bonus.dr.g2": "G2 · R15–R17 (0.3/0.6/0.9%)",
  "bonus.dr.g2sub": "Liderança avançada",
  "bonus.dr.g3": "G3 · R18–R20 (0.3/0.6/0.9%)",
  "bonus.dr.g3sub": "Liderança de elite",
  "bonus.dr.footer": "Taxa = posição dentro do seu grupo. Só é aplicada quando o limite de 3 pagamentos tem espaço.",
  "bonus.dm.title": "Drop Match",
  "bonus.dm.subtitle": "Cotas (não dinheiro) · L1-L3 · sem limite",
  "bonus.dm.row": "{count} membros",
  "bonus.dm.footer": "Drop Match paga cotas (pontos) da U.CENTER, não USD. Sem limite e separado da regra de 3 pagamentos.",
  "bonus.dm.total": "{shares} cotas",

  "share.eyebrow": "Cenário compartilhável",
  "share.title": "Envie esta projeção para um prospect",
  "share.desc": "Cada entrada — pacote, contagens por nível, modo profundo — está embutida na URL. Sem cadastro, sem expiração.",
  "share.linkLabel": "Link de compartilhamento",
  "share.copy": "Copiar",
  "share.copied": "Copiado",
  "share.footer": "Qualquer pessoa com este link chega ao cenário exato que você construiu — com toda a matemática recalculada ao vivo no dispositivo.",
  "share.toast.copied.title": "Link copiado",
  "share.toast.copied.desc": "Cole em qualquer lugar — o cenário inteiro viaja na URL.",
  "share.toast.noPkg.title": "Escolha um pacote primeiro",
  "share.toast.noPkg.desc": "Ao construir um cenário, você poderá compartilhá-lo.",
  "share.toast.loaded.title": "Cenário carregado pelo link",
  "share.toast.loaded.desc": "Todos os dados foram restaurados. Ajuste à vontade.",
  "share.snapshot.youEarn": "Você ganha",
  "share.snapshot.teamPayout": "Pagamento da equipe",
  "share.snapshot.rank": "Rank",

  "lang.select": "Idioma",
};

export default pt;
